// removed by extract-text-webpack-plugin
module.exports = {"ThemeSetting":"ThemeSetting","btn-wrapper":"btn-wrapper","ThemeSetting--content":"ThemeSetting--content"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Website/ThemeSetting/ThemeSetting.scss
// module id = d2qg
// module chunks = 0